import PropTypes from 'prop-types';

// material-ui
import { Box } from '@mui/material';

// project import
import MainCard from 'components/cards/containers/MainCard';

import { useLocation } from 'react-router';

// ==============================|| AUTHENTICATION - CARD WRAPPER ||============================== //

const BaseCard = ({ children, ...other }) => {
  const location = useLocation();
  const { pathname } = location;

  return (
    <MainCard
      sx={{
        maxWidth: { xs: 600, md: 750, lg: 900 },
        // maxWidth: '75%',
        margin: { xs: 2.5, md: 3 },
        '& > *': {
          flexGrow: 1,
          flexBasis: '50%'
        }
      }}
      content={false}
      {...other}
      border={false}
      boxShadow
    >
      <Box sx={{ p: { xs: 2, sm: 3, md: 4, xl: 5 } }}>{children}</Box>
    </MainCard>
  );
};

BaseCard.propTypes = {
  children: PropTypes.node
};

export default BaseCard;
